import React from 'react';
import clsx from 'clsx';
import { FileText, Send } from 'lucide-react';
import { PfmeaItem } from '../../types';

interface DraftItemsListProps {
    draftItems: PfmeaItem[];
    isDark: boolean;
    processing: boolean;
    onSubmit: (item: PfmeaItem) => void;
}

const DraftItemsList: React.FC<DraftItemsListProps> = ({ draftItems, isDark, processing, onSubmit }) => {
    if (draftItems.length === 0) return null;

    return (
        <div className={clsx(
            'rounded-xl border overflow-hidden',
            isDark ? 'border-slate-700' : 'border-slate-200'
        )}>
            <div className={clsx(
                'px-4 py-3 border-b flex items-center justify-between',
                isDark ? 'bg-slate-800 border-slate-700' : 'bg-slate-50 border-slate-200'
            )}>
                <h2 className={clsx('font-semibold flex items-center gap-2', isDark ? 'text-white' : 'text-slate-800')}>
                    <FileText size={18} className="text-slate-400" />
                    Draft Items ({draftItems.length})
                </h2>
                <span className="text-xs text-slate-500">Ready to submit for review</span>
            </div>
            <div className="divide-y divide-slate-200 dark:divide-slate-700">
                {draftItems.slice(0, 5).map(item => (
                    <div
                        key={item.id}
                        className={clsx(
                            'p-3 flex items-center justify-between',
                            isDark ? 'bg-slate-900' : 'bg-white'
                        )}
                    >
                        <div>
                            <span className="text-xs font-mono text-slate-400 mr-2">{item.processStepNumber}</span>
                            <span className={clsx('font-medium', isDark ? 'text-white' : 'text-slate-800')}>
                                {item.processStepName || item.failureMode}
                            </span>
                        </div>
                        <button
                            onClick={() => onSubmit(item)}
                            disabled={processing}
                            className="flex items-center gap-1 px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded hover:bg-blue-200"
                        >
                            <Send size={12} />
                            Submit
                        </button>
                    </div>
                ))}
                {draftItems.length > 5 && (
                    <div className={clsx('p-3 text-center text-sm text-slate-500', isDark ? 'bg-slate-900' : 'bg-white')}>
                        +{draftItems.length - 5} more drafts
                    </div>
                )}
            </div>
        </div>
    );
};

export default DraftItemsList;
